module.exports = OK_REACT_vendors;